export default "__VITE_ASSET__B_KXCK4U__"